import { useTranslation } from 'react-i18next';
import { AppLanguage } from '@anytag/shared-types';
import { cn, localizedDateFormatter } from '@anytag/shared-utils';
import { Anchor, BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface GoogleSlidesHistoryModalProps extends BaseModalProps {
  data: { date: string | number; url: string }[];
}

export const GoogleSlidesHistoryModal = ({ data, ...restProps }: GoogleSlidesHistoryModalProps) => {
  const { t, i18n } = useTranslation();

  return (
    <BaseModal size="lg" title={t('Previously exported Google Slides')} {...restProps}>
      <ul className="pl-4">
        {data?.map((history, index) => (
          <li key={index} className={cn('list-disc', { 'mt-4': index !== 0 })}>
            <p className="font-normal">
              <span className="text-base">
                {localizedDateFormatter(history.date, 'PPP', i18n.language as AppLanguage)}
              </span>
              <br />
              <Anchor
                variant="blue"
                target="_blank"
                href={history.url}
                label={history.url}
                className="inline-block text-sm"
              />
            </p>
          </li>
        ))}
      </ul>
    </BaseModal>
  );
};
